module.exports = __webpack_public_path__ + "static/media/home3.5cf05bba.jpg";